var _circle, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveMic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_620_367)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 14.6387C23.3223 14.6387 22.6729 14.9077 22.1941 15.3865C21.7153 15.8653 21.4463 16.5147 21.4463 17.1919V24.0004C21.4463 24.6775 21.7153 25.3269 22.1941 25.8058C22.6729 26.2846 23.3223 26.5536 23.9995 26.5536C24.6766 26.5536 25.326 26.2846 25.8049 25.8058C26.2837 25.3269 26.5527 24.6775 26.5527 24.0004V17.1919C26.5527 16.5147 26.2837 15.8653 25.8049 15.3865C25.326 14.9077 24.6766 14.6387 23.9995 14.6387V14.6387Z",
    stroke: "white",
    strokeWidth: 1.2766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9569 22.2983V24.0005C29.9569 25.5805 29.3292 27.0958 28.212 28.213C27.0948 29.3303 25.5795 29.9579 23.9994 29.9579C22.4194 29.9579 20.9041 29.3303 19.7869 28.213C18.6696 27.0958 18.042 25.5805 18.042 24.0005V22.2983",
    stroke: "white",
    strokeWidth: 1.2766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.958V33.3623",
    stroke: "white",
    strokeWidth: 1.2766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5957 33.3623H27.4042",
    stroke: "white",
    strokeWidth: 1.2766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_620_367",
    x1: 8.62157,
    y1: 40.2594,
    x2: 57.508,
    y2: -3.4394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D18EFA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMic);
export default __webpack_public_path__ + "static/media/active-mic.768f240a55a2cbfa552cdce965152ec1.svg";
export { ForwardRef as ReactComponent };